import ComparisonTable from "components-for/display/comparison-table";
import Page from "constants/page";
import Qs from "qs";
import useTags from "hooks-for/tags/use-tags";
import { FunctionComponent, memo, useCallback } from "react";
import { IProps } from "./tags-table.types";
import { generatePath } from "react-router-dom";
import { useInteractionQueryParameters } from "hooks-for/filters/use-interaction-query-parameters";
import "./tags-table.scss";

/**
 * A table of agents with data relevant for assessing differences in metrics, volumes etc.
 * @returns A table of tags.
 */
const TagsTable: FunctionComponent<IProps> = () => {
    const filters = useInteractionQueryParameters();
    const { data: tags, isLoading } = useTags();

    /**
     * Navigate to the explore screen to view a tag.
     * @param tagId Clicked tag.
     */
    const exploreTag = useCallback(
        (tagId: string) => {
            const tagIds = filters.tagId ? filters.tagId.concat(tagId) : tagId;
            return generatePath(`${Page.Explore}?:search`, {
                search: Qs.stringify(
                    { ...filters, [typeof filters.agentTagGroupId !== "undefined" ? "agentTagId" : "tagId"]: tagIds },
                    { arrayFormat: "repeat", skipNulls: true, encode: false }
                ),
            });
        },
        [filters]
    );

    return (
        <ComparisonTable
            getGroupId={({ tagId }) => tagId}
            groupBy={typeof filters.agentTagGroupId !== "undefined" ? "agentTagId" : "tagId"}
            groups={isLoading ? [] : tags ?? []}
            groupTitle="Tag"
            headingProperties={{ Tag: ({ tag }) => tag }}
            hasHorizontalScroll
            getRowLink={exploreTag}
            className="comparison-tag-table"
        >
            {({ tag }) => <>{tag}</>}
        </ComparisonTable>
    );
};

export default memo(TagsTable);
